const getters = {
  lifeinpaxels: state => state.lifeinpaxel,
};

export default getters;
